import { Reset } from "../components/user/Reset";

const ResetPassword = () => {
  return <Reset />;
};

export default ResetPassword;
